import { Component } from '@angular/core';
import { DBService } from './core/services/db.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent {
	// inyectamos los servicios necesarios para inicializar lo que corresponda
	constructor(
		private _dbService: DBService
	) { }
}
